
// if ( $('.template-product').length > 0) {
  
//   // load PDP page on top
//   if (history.scrollRestoration) {
//     history.scrollRestoration = 'manual';
//   } else {
//     window.onbeforeunload = function () {
//       window.scrollTo(0, 0);
//     }
//   }
// }



// font testing
if ( $('#fontSize').length > 0 ) {
  var fontSize = $('#fontSize').val();
  // console.log(fontSize);
  
  var fontSizeSlider = document.getElementById("fontSize");
  var fontSizeOutput = document.getElementById("fontSizeValue");
  fontSizeOutput.innerHTML = fontSizeSlider.value;
  
  fontSizeSlider.oninput = function() {
    fontSizeOutput.innerHTML = this.value;
    $('.font-output').css('font-size', fontSizeOutput.innerHTML + 'px');
  }
  
  var lineHeightSlider = document.getElementById("lineHeight");
  var lineHeightOutput = document.getElementById("lineHeightValue");
  lineHeightOutput.innerHTML = lineHeightSlider.value;
  
  lineHeightSlider.oninput = function() {
    lineHeightOutput.innerHTML = this.value;
    $('.font-output').css('line-height', lineHeightOutput.innerHTML + 'px');
  }
  
  var letterSpacingSlider = document.getElementById("letterSpacing");
  var letterSpacingOutput = document.getElementById("letterSpacingValue");
  letterSpacingOutput.innerHTML = letterSpacingSlider.value;
  
  letterSpacingSlider.oninput = function() {
    letterSpacingOutput.innerHTML = this.value;
    $('.font-output').css('letter-spacing', letterSpacingOutput.innerHTML + 'px');
  }
  
  $('#fontName').change(function() {
    var fontName = $(this).val();
    $('.font-output').css('font-family', fontName);
  });

  $('#font-input').on('input', function(){
    var inputValue = $(this).val();
    $('.font-output').text(inputValue);
  });
  
}


if ( $('#icon-mask-image').length > 0 ) {
  // Make sure it always starts @ zero position for below calcs to work
  $("#icon-mask-image").css({top: 0, left: 0});
  
  var maskWidth  = $("#icon-mask").width();
  var maskHeight = $("#icon-mask").height();
  var imgPos     = $("#icon-mask-image").offset();
  var imgWidth   = $("#icon-mask-image").width();
  var imgHeight  = $("#icon-mask-image").height();
  
  var x1 = (imgPos.left + maskWidth) - imgWidth;
  var y1 = (imgPos.top + maskHeight) - imgHeight;
  var x2 = imgPos.left;
  var y2 = imgPos.top;
  
  $("#icon-mask-image").draggable({ containment: [x1,y1,x2,y2] });
  $("#icon-mask-image").css({cursor: 'move'});
}


if ( $('.template-product').length > 0 ) {
  setTimeout(function() { 
    var baseImageHeight = $('.mask img').height();
    // console.log(baseImageHeight);
    $('.mask_overlay').css('height', baseImageHeight);
  }, 1000);
  
  $( window ).resize(function() {
    var baseImageHeight = $('.mask img').height();
    $('.mask_overlay').css('height', baseImageHeight);
  });
  
  // $('.mask_overlay').css('width',$('.mask_handle').css('left'));
  $( ".mask_handle" ).click(function(e){
    e.preventDefault();
  });
  $('.mask_handle').draggable({
    addClasses: true,
    cancel: false,
    classes: {
      "ui-draggable": "highlight"
    },
    containment: "parent",
    axis: "x",
    drag: function( event, ui ) {
        x_position = $(this).css('left');
        new_x_position = x_position.replace('px', '');
        x_position = parseInt(new_x_position)+7;
        $('.mask_overlay').css('width',x_position );
    },
    stop: function( event, ui ) {
      x_position = $(this).css('left');
      new_x_position = x_position.replace('px', '');
      x_position = parseInt(new_x_position)+7;
      $('.mask_overlay').css('width',x_position );
    }
  });
}